import React, { useRef, useEffect, useState } from 'react';
import classNames from 'classnames/bind';

var styles$6 = {"TravelHeader":"Header_TravelHeader__pfaAq"};

var ServiceType;
(function (ServiceType) {
    ServiceType["FLIGHT"] = "flight";
    ServiceType["EVENTPROMOTION"] = "eventpromotion";
    ServiceType["HOTEL"] = "hotel";
    ServiceType["TOUR"] = "tour";
    ServiceType["PKGTOUR"] = "pkgtour";
    ServiceType["TRAVEL4U"] = "foryou";
})(ServiceType || (ServiceType = {}));

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var development = {
    env: 'development',
    url: {
        cdn: 'https://vertical.pstatic.net',
        hotel: 'https://test-hotels.naver.com',
        flight: 'https://test-flight.naver.com',
        pkgtour: 'https://test-pkgtour.naver.com',
        travel4u: 'https://test-travel4u.naver.com',
        tour: 'http://test-m-tour.store.naver.com:11111/local',
        eventpromotion: 'https://test-travel-event.naver.com',
        mypage: 'https://test-travel.naver.com/my',
        travelsearch: 'https://test-travel.naver.com',
        bizflight: 'http://dev.store.naver.com:3000/flights',
        bizflightApi: 'http://dev-flight-front.naver.com',
        bizhotel: 'https://dev.store.naver.com:3000/hotels',
        biztrip: 'https://dev-biztrip.naver.com',
        biztripschedule: 'https://dev-biztrip.naver.com/traveler/business-travel',
        biztripbooking: 'https://dev-biztrip.naver.com/traveler/reservation',
        biztripreport: 'https://dev-biztrip.naver.com/traveler/expense-report',
        bizmypage: 'https://dev-biztrip.naver.com/mypage',
        bizmanage: 'https://dev-biztrip.naver.com/home/manager',
        biztraveler: 'https://dev-biztrip.naver.com/home/traveler',
        bizhotelApi: 'https://test-biz-hotel-api.naver.com',
    },
    splugin: {
        mobile: 'https://dev-spi.naver.com/js/release/ko_KR/splugin.m.js',
        pc: 'https://dev-spi.naver.com/js/release/ko_KR/splugin.js',
    },
};

var test = {
    env: 'test',
    url: {
        cdn: 'https://vertical.pstatic.net',
        hotel: 'https://test-hotels.naver.com',
        flight: 'https://test-flight.naver.com',
        pkgtour: 'https://test-pkgtour.naver.com',
        travel4u: 'https://test-travel4u.naver.com',
        tour: 'http://test-m-tour.store.naver.com:11111/local',
        eventpromotion: 'https://test-travel-event.naver.com',
        mypage: 'https://test-travel.naver.com/my',
        travelsearch: 'https://test-travel.naver.com',
        bizflight: 'https://dev-biztrip.naver.com/flights',
        bizflightApi: 'https://dev-flight-front.naver.com',
        bizhotel: 'https://dev.store.naver.com:3000/hotels',
        biztrip: 'https://dev-biztrip.naver.com',
        biztripschedule: 'https://dev-biztrip.naver.com/traveler/business-travel',
        biztripbooking: 'https://dev-biztrip.naver.com/traveler/reservation',
        biztripreport: 'https://dev-biztrip.naver.com/traveler/expense-report',
        bizmypage: 'https://dev-biztrip.naver.com/mypage',
        bizmanage: 'https://dev-biztrip.naver.com/home/manager',
        biztraveler: 'https://dev-biztrip.naver.com/home/traveler',
        bizhotelApi: 'https://test-biz-hotel-api.naver.com',
    },
    splugin: {
        mobile: 'https://dev-spi.naver.com/js/release/ko_KR/splugin.m.js',
        pc: 'https://dev-spi.naver.com/js/release/ko_KR/splugin.js',
    },
};

var stage = {
    env: 'stage',
    url: {
        cdn: 'https://vertical.pstatic.net',
        hotel: 'https://stage-hotels.naver.com',
        flight: 'https://stage-flight.naver.com',
        pkgtour: 'https://stage-pkgtour.naver.com',
        travel4u: 'https://stage-travel4u.naver.com',
        tour: 'https://stage-m-tour.store.naver.com/local',
        eventpromotion: 'https://stage-travel-event.naver.com',
        mypage: 'https://stage-travel.naver.com/my',
        travelsearch: 'https://stage-travel.naver.com',
        bizflight: 'https://stage-biztrip.naver.com/flights',
        bizflightApi: 'https://stage-flight-front.naver.com',
        bizhotel: 'https://stage-biztrip.naver.com/hotels',
        biztrip: 'https://stage-biztrip.naver.com',
        biztripschedule: 'https://stage-biztrip.naver.com/traveler/business-travel',
        biztripbooking: 'https://stage-biztrip.naver.com/traveler/reservation',
        biztripreport: 'https://stage-biztrip.naver.com/traveler/expense-report',
        bizmypage: 'https://stage-biztrip.naver.com/mypage',
        bizmanage: 'https://stage-biztrip.naver.com/home/manager',
        biztraveler: 'https://stage-biztrip.naver.com/home/traveler',
        bizhotelApi: 'https://stage-biz-hotel-api.naver.com',
    },
    splugin: {
        mobile: 'https://ssl.pstatic.net/spi/js/release/ko_KR/splugin.m.js',
        pc: 'https://ssl.pstatic.net/spi/js/release/ko_KR/splugin.js',
    },
};

var production = {
    env: 'production',
    url: {
        cdn: 'https://vertical.pstatic.net',
        hotel: 'https://hotels.naver.com',
        flight: 'https://flight.naver.com',
        pkgtour: 'https://pkgtour.naver.com',
        travel4u: 'https://travel4u.naver.com',
        tour: 'https://m-tour.store.naver.com/local',
        eventpromotion: 'https://travel-event.naver.com',
        mypage: 'https://travel.naver.com/my',
        travelsearch: 'https://travel.naver.com',
        bizflight: 'https://biztrip.naver.com/flights',
        bizflightApi: 'https://flight-front.naver.com',
        bizhotel: 'https://biztrip.naver.com/hotels',
        biztrip: 'https://biztrip.naver.com',
        biztripschedule: 'https://biztrip.naver.com/traveler/business-travel',
        biztripbooking: 'https://biztrip.naver.com/traveler/reservation',
        biztripreport: 'https://biztrip.naver.com/traveler/expense-report',
        bizmypage: 'https://biztrip.naver.com/mypage',
        bizmanage: 'https://biztrip.naver.com/home/manager',
        biztraveler: 'https://biztrip.naver.com/home/traveler',
        bizhotelApi: 'https://biz-hotel-api.naver.com',
    },
    splugin: {
        mobile: 'https://ssl.pstatic.net/spi/js/release/ko_KR/splugin.m.js',
        pc: 'https://ssl.pstatic.net/spi/js/release/ko_KR/splugin.js',
    },
};

var commonConfig = {
    nAuthWithUrlParam: "https://nid.naver.com/nidlogin.login?svctype=262144&url=",
};

var _a;
var configMap = new Map([
    ['test', test],
    ['stage', stage],
    ['production', production],
]);
var env = process.env.APP_ENV || process.env.NODE_ENV;
if (typeof window !== 'undefined') {
    env = ((_a = window === null || window === void 0 ? void 0 : window.__ENV) === null || _a === void 0 ? void 0 : _a.APP_ENV) || env;
}
var getConfig = function () {
    if (process.env.APP_ENV === 'production')
        return __assign(__assign({}, production), commonConfig);
    if (process.env.APP_ENV === 'development')
        return __assign(__assign({}, development), commonConfig);
    if (process.env.APP_ENV === 'test')
        return __assign(__assign({}, test), commonConfig);
    if (process.env.APP_ENV === 'stage')
        return __assign(__assign({}, stage), commonConfig);
    var envConfig = configMap.get(env || 'production') || production;
    return __assign(__assign({}, envConfig), commonConfig);
};
var config = getConfig();

function getLnbList() {
    var orgGnbList = [
        {
            href: config.url.eventpromotion,
            nClickCode: 'gnb.event',
            title: '여행핫딜',
            service: ServiceType.EVENTPROMOTION,
            iconKey: 'hotdeal',
        },
        {
            href: config.url.flight,
            nClickCode: 'gnb.flights',
            title: '항공',
            service: ServiceType.FLIGHT,
        },
        {
            href: config.url.hotel,
            nClickCode: 'gnb.hotels',
            title: '호텔',
            service: ServiceType.HOTEL,
        },
        {
            href: config.url.pkgtour,
            nClickCode: 'gnb.pkgtour',
            title: '패키지',
            service: ServiceType.PKGTOUR,
        },
        {
            href: config.url.biztraveler,
            nClickCode: 'gnb.biztrip',
            title: '출장',
            service: 'biztrip',
            iconKey: 'outlink',
        },
        {
            href: config.url.travel4u,
            nClickCode: 'gnb.travel4u',
            title: 'For U',
            service: ServiceType.TRAVEL4U,
            moveScroll: 'END',
        },
    ];
    return orgGnbList;
}
function getGnbList() {
    var orgGnbList = [
        {
            href: config.url.flight,
            nClickCode: 'gnb.flights',
            title: '여행상품',
            service: ServiceType.FLIGHT,
        },
        {
            href: config.url.travelsearch,
            nClickCode: 'gnb.tour',
            title: '여행정보',
            service: 'travelsearch',
        },
    ];
    return orgGnbList;
}

var useOffClick = function (onOffClick, stopPropagation) {
    if (stopPropagation === void 0) { stopPropagation = false; }
    var ref = useRef(null);
    var savedOffClickHandler = useRef(onOffClick);
    var handleClickOutside = function (e) {
        if ((ref === null || ref === void 0 ? void 0 : ref.current) && !ref.current.contains(e.target)) {
            if (stopPropagation)
                e.stopPropagation();
            savedOffClickHandler.current(e);
        }
    };
    useEffect(function () {
        savedOffClickHandler.current = onOffClick;
    });
    useEffect(function () {
        document.addEventListener('click', handleClickOutside, true);
        return function () {
            return document.removeEventListener('click', handleClickOutside, true);
        };
    }, []);
    return ref;
};

var styles$5 = {"MembershipPopup":"MembershipPopup-module_MembershipPopup__Tkqgo","layer":"MembershipPopup-module_layer__Z33aB","title":"MembershipPopup-module_title__Ced-S","desc":"MembershipPopup-module_desc__VZIxL","grade":"MembershipPopup-module_grade__pXTsr","close":"MembershipPopup-module_close__-Cf8M","GradeInfo":"MembershipPopup-module_GradeInfo__jpYdR","smart":"MembershipPopup-module_smart__J1zM1","highlight":"MembershipPopup-module_highlight__BuZqb","gold":"MembershipPopup-module_gold__KwbKU","anchor":"MembershipPopup-module_anchor__-kA-i"};

var TravelClubGrade;
(function (TravelClubGrade) {
    TravelClubGrade[TravelClubGrade["NONE"] = 0] = "NONE";
    TravelClubGrade[TravelClubGrade["BASIC"] = 1] = "BASIC";
    TravelClubGrade[TravelClubGrade["SMART"] = 2] = "SMART";
    TravelClubGrade[TravelClubGrade["GOLD"] = 3] = "GOLD";
})(TravelClubGrade || (TravelClubGrade = {}));

var getGradeName = function (grade) {
    switch (grade) {
        case TravelClubGrade.BASIC:
            return "베이직";
        case TravelClubGrade.SMART:
            return "스마트";
        case TravelClubGrade.GOLD:
            return "골드";
        default:
            return "";
    }
};

var styles$4 = {"GradeInfo":"GradeInfo-module_GradeInfo__EfyNr","title":"GradeInfo-module_title__tEvlQ","info_list":"GradeInfo-module_info_list__RPm-R","item":"GradeInfo-module_item__jjsEj","main":"GradeInfo-module_main__SeBPp","sub":"GradeInfo-module_sub__p6iOQ","txt":"GradeInfo-module_txt__NJULV","txt_list":"GradeInfo-module_txt_list__m42c4","smart":"GradeInfo-module_smart__uvnU-","point":"GradeInfo-module_point__NakAH","gold":"GradeInfo-module_gold__bG8-o","caution":"GradeInfo-module_caution__LHy4i","notification":"GradeInfo-module_notification__WHxbj","highlight":"GradeInfo-module_highlight__magnJ","noti_box":"GradeInfo-module_noti_box__Myjnp","switch":"GradeInfo-module_switch__ccSfz","GradeButtonGroup":"GradeInfo-module_GradeButtonGroup__EFj1W","GradeButtonGroupItem":"GradeInfo-module_GradeButtonGroupItem__WhcAS"};

var cx$7 = classNames.bind(styles$4);
var GradeButtonGroup = function (_a) {
    var selectedGrade = _a.selectedGrade, setSelectedGrade = _a.setSelectedGrade, nClick = _a.nClick, gradeNClickCode = _a.gradeNClickCode;
    return (React.createElement("ul", { className: cx$7("GradeButtonGroup") }, [TravelClubGrade.BASIC, TravelClubGrade.SMART, TravelClubGrade.GOLD].map(function (v, i) { return (React.createElement("li", { key: i, className: cx$7("GradeButtonGroupItem") },
        React.createElement("button", { className: cx$7("item"), "data-grade": v, "aria-selected": selectedGrade === v, type: "button", onClick: function (e) {
                if (nClick && gradeNClickCode)
                    nClick(gradeNClickCode, e);
                setSelectedGrade(v);
            } }, getGradeName(v)))); })));
};
var BasicGradeInfo = function (_a) {
    var selectedGrade = _a.selectedGrade, setSelectedGrade = _a.setSelectedGrade, nClick = _a.nClick, gradeNClickCode = _a.gradeNClickCode;
    return (React.createElement("div", { className: cx$7("GradeInfo", "basic") },
        React.createElement("span", { className: cx$7("txt") }, "\uB4F1\uAE09\uBCC4 \uAE30\uC900 \uBC0F \uD61C\uD0DD"),
        React.createElement(GradeButtonGroup, { selectedGrade: selectedGrade, setSelectedGrade: setSelectedGrade, nClick: nClick, gradeNClickCode: gradeNClickCode }),
        React.createElement("dl", { className: cx$7("info_list") },
            React.createElement("div", { className: cx$7("item") },
                React.createElement("dt", { className: cx$7("main") }, "\uAE30\uC900"),
                React.createElement("dd", { className: cx$7("sub") }, "\uB124\uC774\uBC84 \uB85C\uADF8\uC778 \uD68C\uC6D0")),
            React.createElement("div", { className: cx$7("item") },
                React.createElement("dt", { className: cx$7("main") }, "\uD61C\uD0DD"),
                React.createElement("dd", { className: cx$7("sub") }, "\uC5EC\uD589\uC0C1\uD488 \uAE30\uBCF8 \uD560\uC778/\uC801\uB9BD \uC801\uC6A9")))));
};
var SmartGradeInfo = function (_a) {
    var selectedGrade = _a.selectedGrade, setSelectedGrade = _a.setSelectedGrade, nClick = _a.nClick, gradeNClickCode = _a.gradeNClickCode;
    return (React.createElement("div", { className: cx$7("GradeInfo", "smart") },
        React.createElement("span", { className: cx$7("title") }, "\uB4F1\uAE09\uBCC4 \uAE30\uC900 \uBC0F \uD61C\uD0DD"),
        React.createElement(GradeButtonGroup, { selectedGrade: selectedGrade, setSelectedGrade: setSelectedGrade, nClick: nClick, gradeNClickCode: gradeNClickCode }),
        React.createElement("dl", { className: cx$7("info_list") },
            React.createElement("div", { className: cx$7("item") },
                React.createElement("dt", { className: cx$7("main") }, "\uAE30\uC900"),
                React.createElement("dd", { className: cx$7("sub") }, "\uC5EC\uD589\uC0C1\uD488 \uCD1D 3\uD68C \uC774\uC0C1 \uAD6C\uB9E4")),
            React.createElement("div", { className: cx$7("item") },
                React.createElement("dt", { className: cx$7("main") }, "\uD61C\uD0DD"),
                React.createElement("dd", { className: cx$7("sub") },
                    React.createElement("ul", { className: cx$7("txt_list") },
                        React.createElement("li", { className: cx$7("item") }, "\uC5EC\uD589\uC0C1\uD488 \uC2A4\uB9C8\uD2B8 \uB4F1\uAE09 \uD560\uC778 \uC694\uAE08"),
                        React.createElement("li", { className: cx$7("item") },
                            "\uC5EC\uD589\uC0C1\uD488 \uAD6C\uB9E4\uAC74\uB9C8\uB2E4",
                            React.createElement("i", { className: cx$7("point") }, " \uCD94\uAC00 \uC801\uB9BD"))))))));
};
var GoldGradeInfo = function (_a) {
    var selectedGrade = _a.selectedGrade, setSelectedGrade = _a.setSelectedGrade, nClick = _a.nClick, gradeNClickCode = _a.gradeNClickCode;
    return (React.createElement("div", { className: cx$7("GradeInfo", "gold") },
        React.createElement("span", { className: cx$7("title") }, "\uB4F1\uAE09\uBCC4 \uAE30\uC900 \uBC0F \uD61C\uD0DD"),
        React.createElement(GradeButtonGroup, { selectedGrade: selectedGrade, setSelectedGrade: setSelectedGrade, nClick: nClick, gradeNClickCode: gradeNClickCode }),
        React.createElement("dl", { className: cx$7("info_list") },
            React.createElement("div", { className: cx$7("item") },
                React.createElement("dt", { className: cx$7("main") }, "\uAE30\uC900"),
                React.createElement("dd", { className: cx$7("sub") }, "\uC5EC\uD589\uC0C1\uD488 \uCD1D 7\uD68C \uC774\uC0C1 \uAD6C\uB9E4")),
            React.createElement("div", { className: cx$7("item") },
                React.createElement("dt", { className: cx$7("main") }, "\uD61C\uD0DD"),
                React.createElement("dd", { className: cx$7("sub") },
                    React.createElement("ul", { className: cx$7("txt_list") },
                        React.createElement("li", { className: cx$7("item") }, "\uC5EC\uD589\uC0C1\uD488 \uACE8\uB4DC \uB4F1\uAE09 \uD560\uC778 \uC694\uAE08"),
                        React.createElement("li", { className: cx$7("item") },
                            "\uC5EC\uD589\uC0C1\uD488 \uAD6C\uB9E4\uAC74\uB9C8\uB2E4",
                            React.createElement("i", { className: cx$7("point") }, " \uCD94\uAC00 \uC801\uB9BD"))))))));
};
var getGradeInfoComponent = function (selectedGrade) {
    switch (selectedGrade) {
        case 3:
            return GoldGradeInfo;
        case 2:
            return SmartGradeInfo;
        default:
            return BasicGradeInfo;
    }
};
var GradeInfo = function (_a) {
    var initGrade = _a.initGrade, nClick = _a.nClick, gradeNClickCode = _a.gradeNClickCode;
    var _b = useState(initGrade), selectedGrade = _b[0], setSelectedGrade = _b[1];
    var GradeInfoComponent = getGradeInfoComponent(selectedGrade);
    return (React.createElement(GradeInfoComponent, { selectedGrade: selectedGrade, setSelectedGrade: setSelectedGrade, nClick: nClick, gradeNClickCode: gradeNClickCode }));
};

var cx$6 = classNames.bind(styles$5);
var MembershipPopup = function (_a) {
    var travelUser = _a.travelUser, closeGradePopup = _a.closeGradePopup, nClick = _a.nClick, gradeNClickCode = _a.gradeNClickCode, closeNClickCode = _a.closeNClickCode, moreNClickCode = _a.moreNClickCode;
    var ref = useOffClick(closeGradePopup);
    return (React.createElement("div", { className: cx$6("MembershipPopup"), "aria-modal": "true" },
        React.createElement("div", { className: cx$6("layer"), ref: ref },
            React.createElement("b", { className: cx$6("title") }, "\uB124\uC774\uBC84 \uD2B8\uB798\uBE14\uD074\uB7FD"),
            React.createElement("span", { className: cx$6("desc") },
                travelUser.nickName,
                "\uB2D8\uC740",
                React.createElement("b", { className: cx$6("grade"), "data-grade": travelUser.grade }, "".concat(getGradeName(travelUser.grade), "\uB4F1\uAE09")),
                "\uC785\uB2C8\uB2E4."),
            React.createElement(GradeInfo, { initGrade: travelUser.grade, nClick: nClick, gradeNClickCode: gradeNClickCode }),
            React.createElement("a", { className: cx$6("anchor"), href: "https://travel-event.naver.com/promotion/travelclub", onClick: function (e) {
                    if (nClick && moreNClickCode)
                        nClick(moreNClickCode, e);
                } }, "\uB4F1\uAE09\uBCC4 \uD61C\uD0DD \uC790\uC138\uD788 \uBCF4\uAE30"),
            React.createElement("button", { type: "button", className: cx$6("close"), onClick: function (e) {
                    if (nClick && closeNClickCode)
                        nClick(closeNClickCode, e);
                    closeGradePopup();
                } }))));
};

var styles$3 = {"TravelClubGradeButton":"index-module_TravelClubGradeButton__PLdtk","TravelClubLogin":"index-module_TravelClubLogin__0p6hz","MyPageButton":"index-module_MyPageButton__EBhU7","text":"index-module_text__GYotD"};

var decodeString = function (string) {
    return decodeURIComponent(string.replace(/\+/g, " "));
};
var getQuerystring = function () {
    var queries = {};
    var queryString = window.location.search.substring(1);
    var keyValues = queryString.split("&");
    keyValues.map(function (keyValue) {
        var _a = keyValue.split("="), key = _a[0], value = _a[1];
        if (key && value)
            queries[decodeString(key)] = decodeString(value);
    });
    return queries;
};

var useTravelClubPopup = function (usePopup) {
    if (usePopup === void 0) { usePopup = true; }
    var _a = useState(false), isPopupOpen = _a[0], setIsPopupOpen = _a[1];
    var openGradePopup = function () {
        setIsPopupOpen(true);
    };
    var closeGradePopup = function () {
        setIsPopupOpen(false);
    };
    var _b = useState(''), loginLinkWithPopup = _b[0], setLoginLinkWithPopup = _b[1];
    useEffect(function () {
        if (!usePopup)
            return;
        var popup = getQuerystring().popup;
        if (popup === 'open') {
            openGradePopup();
            window.history.replaceState({}, '', window.location.href.replace('popup=open', ''));
        }
    }, []);
    useEffect(function () {
        var updateLoginLink = function () {
            var queryObject = __assign(__assign({}, getQuerystring()), { popup: 'open' });
            var queryString = Object.keys(queryObject)
                .map(function (key) { return "".concat(key, "=").concat(queryObject[key]); })
                .join('&');
            setLoginLinkWithPopup("".concat(config.nAuthWithUrlParam).concat(window.location.origin).concat(window.location.pathname).concat(encodeURIComponent("?".concat(queryString))));
        };
        updateLoginLink();
        window.addEventListener('popstate', updateLoginLink);
        // History API override
        var originalPushState = history.pushState;
        var originalReplaceState = history.replaceState;
        history.pushState = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            originalPushState.apply(history, args);
            updateLoginLink();
        };
        history.replaceState = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            originalReplaceState.apply(history, args);
            updateLoginLink();
        };
        return function () {
            window.removeEventListener('popstate', updateLoginLink);
            history.pushState = originalPushState;
            history.replaceState = originalReplaceState;
        };
    }, []);
    return {
        isPopupOpen: isPopupOpen,
        openGradePopup: openGradePopup,
        closeGradePopup: closeGradePopup,
        loginLinkWithPopup: loginLinkWithPopup,
    };
};

var useIsLogin = function () {
    var _a = useState(false), isLogin = _a[0], setIsLogin = _a[1];
    useEffect(function () {
        setIsLogin(document.cookie.includes("NID_SES="));
    }, []);
    return isLogin;
};

var cx$5 = classNames.bind(styles$3);
/**
 * GradeButton 컴포넌트입니다.
 *
 * @props travelUser - 트래블유저 정보
 *
 */
var GradeButton = function (_a) {
    var travelUser = _a.travelUser;
    var _b = useTravelClubPopup(), isPopupOpen = _b.isPopupOpen, openGradePopup = _b.openGradePopup, closeGradePopup = _b.closeGradePopup, loginLinkWithPopup = _b.loginLinkWithPopup;
    var isLogin = useIsLogin();
    return (React.createElement(React.Fragment, null,
        isLogin && travelUser && (React.createElement("button", { type: "button", onClick: openGradePopup, className: cx$5("TravelClubGradeButton"), "data-grade": travelUser.grade },
            React.createElement("span", null, getGradeName(travelUser.grade)))),
        !isLogin && !travelUser && (React.createElement("a", { className: cx$5("TravelClubLogin"), href: loginLinkWithPopup }, "\uB85C\uADF8\uC778 \uD6C4 \uB4F1\uAE09\uD655\uC778")),
        isPopupOpen && travelUser && (React.createElement(MembershipPopup, { travelUser: travelUser, closeGradePopup: closeGradePopup }))));
};

var cx$4 = classNames.bind(styles$3);
var MyPageButton = function (_a) {
    var url = _a.url, _b = _a.nClick, nClick = _b === void 0 ? function () { } : _b, _c = _a.newWindow, newWindow = _c === void 0 ? false : _c;
    return (React.createElement("a", { className: cx$4('MyPageButton'), href: url, onClick: function (e) { return nClick('gnb.my', e); }, target: newWindow ? '_blank' : '_self', rel: "noreferrer" },
        React.createElement("span", { className: cx$4('text') }, "\uB9C8\uC774\uD398\uC774\uC9C0")));
};

var styles$2 = {"NaverGnb":"NaverGnb-module_NaverGnb__ycUd3"};

var cx$3 = classNames.bind(styles$2);
var NaverGnb = function () {
    var naverGnbRef = useRef(null);
    var getNaverGnb = function () {
        if (window) {
            window.gnb_service = "travel-event";
            window.gnb_template = "gnb_utf8";
            window.gnb_brightness = 3;
            window.gnb_one_naver = 1;
        }
        var script = document.createElement("script");
        script.src = "https://ssl.pstatic.net/static.gn/templates/gnb_utf8.nhn";
        script.async = true;
        script.onload = function () {
            if (window && window.getGNB)
                window.getGNB();
        };
        return script;
    };
    useEffect(function () {
        if (naverGnbRef && naverGnbRef.current) {
            naverGnbRef.current.appendChild(getNaverGnb());
        }
    }, []);
    return (React.createElement("div", { className: cx$3('NaverGnb') },
        React.createElement("div", { id: "gnb", ref: naverGnbRef })));
};

var styles$1 = {"PcLayout":"PcLayout-module_PcLayout__oC-A3","naver":"PcLayout-module_naver__QHi6X","text":"PcLayout-module_text__BhJ74","naver_gnb":"PcLayout-module_naver_gnb__WWW4e"};

var cx$2 = classNames.bind(styles$1);
var PcLayout = function (_a) {
    var naverGnbElement = _a.naverGnbElement, _b = _a.nClick, nClick = _b === void 0 ? function (code) { } : _b;
    return (React.createElement("div", { className: cx$2('PcLayout') },
        React.createElement("a", { className: cx$2('naver'), href: 'https://www.naver.com/', onClick: function (e) { return nClick('gnb.naver', e); } },
            React.createElement("span", { className: cx$2('text') }, "Naver")),
        naverGnbElement && (React.createElement("div", { className: cx$2('naver_gnb') }, naverGnbElement))));
};

var styles = {"HeaderContent":"HeaderContent-module_HeaderContent__3wMS4","gnb":"HeaderContent-module_gnb__c9X0k","naver":"HeaderContent-module_naver__z2fhq","text":"HeaderContent-module_text__RPHv3","home":"HeaderContent-module_home__XJzfa","information":"HeaderContent-module_information__vDyxw","sub":"HeaderContent-module_sub__nN4hQ","lnb":"HeaderContent-module_lnb__13K4V","scroller":"HeaderContent-module_scroller__YxvP6"};

var cx$1 = classNames.bind(styles);
var HeaderContent = function (_a) {
    var service = _a.service, gnbList = _a.gnbList, lnbList = _a.lnbList, _b = _a.nClick, nClick = _b === void 0 ? function (code) { } : _b, subButtons = _a.subButtons;
    var selectedLnb = lnbList.find(function (item) { return item.service === service; });
    var scrollRef = useRef(null);
    useEffect(function () {
        if (scrollRef.current && (selectedLnb === null || selectedLnb === void 0 ? void 0 : selectedLnb.moveScroll))
            scrollRef.current.scrollLeft =
                selectedLnb.moveScroll === 'END'
                    ? scrollRef.current.scrollWidth
                    : selectedLnb.moveScroll;
    }, [selectedLnb === null || selectedLnb === void 0 ? void 0 : selectedLnb.moveScroll]);
    return (React.createElement("div", { className: cx$1('HeaderContent') },
        React.createElement("nav", { className: cx$1('gnb') },
            React.createElement("a", { className: cx$1('naver'), href: 'https://www.naver.com/', onClick: function (e) { return nClick('gnb.naver', e); } },
                React.createElement("span", { className: cx$1('text') }, "Naver")),
            React.createElement("a", { className: cx$1('home'), href: gnbList[0].href, onClick: function (e) {
                    return gnbList[0].nClickCode && nClick(gnbList[0].nClickCode, e);
                } },
                React.createElement("span", { className: cx$1('text') }, gnbList[0].title)),
            gnbList[1] && (React.createElement("a", { className: cx$1('information'), href: gnbList[1].href, onClick: function (e) {
                    return gnbList[1].nClickCode && nClick(gnbList[1].nClickCode, e);
                } },
                React.createElement("span", { className: cx$1('text') }, gnbList[1].title))),
            subButtons && (React.createElement("div", { className: cx$1('sub') }, subButtons))),
        React.createElement("nav", { className: cx$1('lnb'), "aria-label": "\uC5EC\uD589 \uC11C\uBE44\uC2A4" },
            React.createElement("div", { className: cx$1('scroller'), ref: scrollRef }, lnbList.map(function (lnbItem, i) { return (React.createElement("a", { key: i, "aria-current": service === lnbItem.service ? 'page' : undefined, href: lnbItem.href, onClick: function (e) { return lnbItem.nClickCode && nClick(lnbItem.nClickCode, e); }, "data-icon-key": lnbItem.iconKey },
                React.createElement("span", null, lnbItem.title),
                lnbItem.iconKey === 'hotdeal' && React.createElement("i", null))); })))));
};

var cx = classNames.bind(styles$6);
/**
 * Header 컴포넌트입니다.
 *
 * @props service - 컴포넌트에 추가할 클래스 이름
 * @props fullbleed - 풀블리드 여부 (ex 호텔쪽에서 (호텔 목록) 가로사이즈가 계속 늘어나는 레이아웃에서 쓰이는 형태입니다)
 * @props nClick - nClick 함수 (code, event) => void
 * @props subButtons - gnb에 추가로 표시될 버튼들의 컴포넌트들
 * @props NaverGnbElement - 네이버 GNB 컴포넌트
 */
var Header = function (_a) {
    var service = _a.service, _b = _a.fullbleed, fullbleed = _b === void 0 ? false : _b, _c = _a.nClick, nClick = _c === void 0 ? function (code) { } : _c, subButtons = _a.subButtons, _d = _a.naverGnbElement, naverGnbElement = _d === void 0 ? React.createElement(NaverGnb, null) : _d;
    var gnbList = getGnbList();
    var lnbList = getLnbList();
    return (React.createElement("div", { className: cx('TravelHeader'), "data-fullbleed": fullbleed, "data-service": service },
        React.createElement(PcLayout, { naverGnbElement: naverGnbElement, nClick: nClick }),
        React.createElement(HeaderContent, { service: service, gnbList: gnbList, lnbList: lnbList, nClick: nClick, subButtons: subButtons })));
};

export { GradeButton, MembershipPopup, MyPageButton, NaverGnb, ServiceType, Header as default };
